import React from 'react';
import { Award, Users, Globe, TrendingUp } from 'lucide-react';

const About = ({ t }) => {
  const features = [
    {
      icon: Award,
      title: '5+ Years',
      subtitle: 'Experience'
    },
    {
      icon: Users,
      title: '500+',
      subtitle: 'Workers Placed'
    },
    {
      icon: Globe,
      title: '20+',
      subtitle: 'German Cities'
    },
    {
      icon: TrendingUp,
      title: '98%',
      subtitle: 'Success Rate'
    }
  ];

  return (
    <section id="about" className="relative py-24 px-4 bg-gradient-to-b from-white via-slate-50/50 to-white overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-10 w-72 h-72 bg-gradient-to-br from-emerald-100/40 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-80 h-80 bg-gradient-to-tr from-blue-100/30 to-transparent rounded-full blur-3xl"></div>
      </div>
      <div className="container mx-auto relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left - Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <img
                src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&h=300&fit=crop"
                alt="Office teamwork"
                className="rounded-xl w-full h-48 object-cover shadow-lg"
              />
              <img
                src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=400&fit=crop"
                alt="Professional meeting"
                className="rounded-xl w-full h-64 object-cover shadow-lg"
              />
            </div>
            <div className="space-y-4 pt-12">
              <img
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=400&fit=crop"
                alt="Business consultation"
                className="rounded-xl w-full h-64 object-cover shadow-lg"
              />
              <img
                src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400&h=300&fit=crop"
                alt="Working professionals"
                className="rounded-xl w-full h-48 object-cover shadow-lg"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            <div>
              <div className="inline-block px-4 py-2 bg-emerald-50 text-emerald-700 rounded-full text-sm font-semibold mb-4">
                {t.nav.about}
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
                {t.about.title}
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                {t.about.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
